var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIconMyCollectionActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav-icon-my-collection-active",
    transform: "translate(-140 -162)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5667",
    "data-name": "Rectangle 5667",
    width: 34,
    height: 34,
    transform: "translate(140 162)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6978",
    "data-name": "Group 6978",
    transform: "translate(115 -153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(-3564.408 -152.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 13.779,
    height: 13.78,
    rx: 1.83,
    transform: "translate(3591.408 469.275)",
    fill: "none",
    stroke: "#190a4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 13.779,
    height: 13.78,
    rx: 1.83,
    transform: "translate(3608.293 469.275)",
    fill: "none",
    stroke: "#190a4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 13.779,
    height: 13.78,
    rx: 1.83,
    transform: "translate(3591.408 486.111)",
    fill: "none",
    stroke: "#190a4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 13.779,
    height: 13.78,
    rx: 1.83,
    transform: "translate(3608.293 486.111)",
    fill: "none",
    stroke: "#190a4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconMyCollectionActive);
export default __webpack_public_path__ + "static/media/nav-icon-my-collection-active.f767f6059febf983bdb8b0729a87e567.svg";
export { ForwardRef as ReactComponent };